import React, { useEffect, useRef, useState } from "react";
import { fetchHomecommunitylist } from "../services/Homecommunitylist";
import { API_BASE } from "../api/apiConfig";

const Homecommunitylist = () => {
  const [community, setcommunity] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchHomecommunitylist();
      if (res?.status && Array.isArray(res.data)) {
        setcommunity(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(community.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      community
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredcommunity = community.filter((m) => {
    if (activeCountry !== "All" && m.country !== activeCountry) return false;
    if (activeCity !== "All" && m.city !== activeCity) return false;
    return true;
  });

  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
    <section className="relative w-full bg-gradient-to-b from-slate-50 to-white py-12 overflow-hidden travel-community-section">
    <div className="absolute top-10 left-10 w-32 h-32 rounded-full bg-teal-500/10 blur-3xl" />
    <div className="absolute bottom-10 right-10 w-40 h-40 rounded-full bg-indigo-500/10 blur-3xl" />

    <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 reveal-on-scroll text-center revealed">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-50 border border-teal-200 mb-4">
                <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-4 w-4 text-teal-600"
                >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <span className="text-sm font-medium text-teal-700">
                Active Communities
                </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-3">
                Join Your <span className="text-gradient">City Community</span>
            </h2>
            <p className="text-slate-600 text-base max-w-2xl mx-auto">
                Connect with travelers in your city. Share experiences, join meetups, and
                explore together
            </p>
        </div>

        <div className="relative">
        <button 
          onClick={() => scrollSlider("prev")}
            className="customPrevBtnCommunity absolute -left-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white border-2 border-teal-200 text-teal-600 shadow-lg transition-all hover:bg-teal-50 hover:scale-110"
            aria-label="Previous highlight"
        >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-left h-5 w-5"
            >
            <path d="m15 18-6-6 6-6" />
            </svg>
        </button>

         <div
              ref={sliderRef}
              className="flex w-full gap-4 overflow-x-auto scroll-smooth pb-6 scrollbar-hide"
            >


        {filteredcommunity.map((item, i) => (
            <a
                className="relative min-w-[320px] flex-shrink-0 snap-start group"
                href={`/CommunityDtl/${item.id}`}
                >
                <div className="relative h-[390px] rounded-2xl overflow-hidden bg-white border border-slate-200 shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2">
                    <div className="relative h-56 overflow-hidden">
                    <img
                        alt={item.city}
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover transition-transform duration-700 group-hover:scale-110"
                        style={{
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        inset: 0,
                        color: "transparent"
                        }}
                        src={
                          item.image
                            ? `${API_BASE}${item.image}`
                            : `${API_BASE}default.jpg`
                        }
                    />
                    <div className="absolute inset-0 bg-gradient-to-b from-blue-500/20 to-indigo-500/20" />
                  {item?.tag && (
                   <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm border border-white/20 shadow-sm">
                        <span className="text-xs font-semibold text-slate-700">
                         {item.tag}
                        </span>
                    </div>
                  )}
                    </div>
                    <div className="p-5">
                    <div className="flex items-center gap-2 mb-4">
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-map-pin h-5 w-5 text-teal-600"
                        >
                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                        <circle cx={12} cy={10} r={3} />
                        </svg>
                        <h3 className="text-xl font-bold text-slate-800">{item.city}</h3>
                    </div>
                    <div className="grid grid-cols-2 gap-3 mb-4">
                        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-3 border border-blue-100">
                        <div className="flex items-center gap-1.5 mb-1">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-users h-4 w-4 text-blue-600"
                            >
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx={9} cy={7} r={4} />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                            <span className="text-xs font-medium text-blue-700">Members</span>
                        </div>
                        <p className="text-lg font-bold text-slate-800">{item.active_member}</p>
                        </div>
                        <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-lg p-3 border border-teal-100">
                        <div className="flex items-center gap-1.5 mb-1">
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-calendar h-4 w-4 text-teal-600"
                            >
                            <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                            <line x1={16} x2={16} y1={2} y2={6} />
                            <line x1={8} x2={8} y1={2} y2={6} />
                            <line x1={3} x2={21} y1={10} y2={10} />
                            </svg>
                            <span className="text-xs font-medium text-teal-700">Meetups</span>
                        </div>
                        <p className="text-lg font-bold text-slate-800">{item.monthly_meetups}</p>
                        </div>
                    </div>
                 
                    
                    </div>
                </div>
            </a>
        ))}


        <div className="relative min-w-[320px] flex-shrink-0 snap-start">
                    <a className="block h-[390px]" href="/community">
                      <div className="h-full rounded-2xl bg-gradient-to-br from-teal-500 via-cyan-500 to-blue-500 p-[2px] hover:shadow-2xl transition-all duration-500 hover:-translate-y-2">
                        <div className="h-full rounded-2xl bg-white flex flex-col items-center justify-center p-8 text-center">
                          <div className="mb-6 rounded-full bg-gradient-to-br from-teal-100 to-cyan-100 p-6">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-users h-12 w-12 text-teal-600"
                            >
                              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                              <circle cx={9} cy={7} r={4} />
                              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                            </svg>
                          </div>
                          <h3 className="text-2xl font-bold text-slate-800 mb-3">
                            Explore All Communities
                          </h3>
                          <p className="text-slate-600 mb-6">
                            Discover communities in 25+ cities across India
                          </p>
                          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 px-4 py-2 bg-gradient-to-r from-teal-600 to-cyan-600 hover:from-teal-700 hover:to-cyan-700 text-white">
                            View All Cities
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-chevron-right ml-2 h-4 w-4"
                            >
                              <path d="m9 18 6-6-6-6" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </a>
                  </div>


        </div>
        <button onClick={() => scrollSlider("next")}
            className="customNextBtnCommunity absolute -right-4 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white border-2 border-teal-200 text-teal-600 shadow-lg transition-all hover:bg-teal-50 hover:scale-110 md:right-0"
            aria-label="Next highlight"
        >
            <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-chevron-right h-5 w-5"
            >
            <path d="m9 18 6-6-6-6" />
            </svg>
        </button>
        </div>
       
       
    </div>
    </section>
  );
};

export default Homecommunitylist;
